let Module_Map = {init: null};
export {Module_Map as Map}
import { NSToolDraw } from './tool_draw';
import { NSObjDetailsEdit } from './obj_details_edit';
import { NSGeoJson } from './utils/geojson';

import Map from 'ol/Map';
import View from 'ol/View';

import {OSM, Vector as VectorSource} from 'ol/source';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer';

import Stamen from 'ol/source/Stamen';
import Zoom from 'ol/control/Zoom';
import ScaleLine from 'ol/control/ScaleLine';

import { OverlaysWMTS } from './overlays_wmts';
import {xCore, xCoreHelper} from './core';

import {ScaleControl} from './map_scale';
import {ImersiveModeControl} from './map_imersive_mode_control';
import {StreetViewModeControl} from './map_street_view_mode_control';
import { NSFeaturesSelect } from './map_features_select';
import { NSMiniClientMain } from './mini_client_main'
import { NSStreetView } from './street_view';

let map;
let s_current_basemap_layer_internal_name;

let private_objs = {
  settings: null,
  o_struct_layers : {
    o_layers: {
      blank: new TileLayer({source: null}),
      osm: new TileLayer({
        source: new OSM()
      }),
      toner: new TileLayer({
        source: new Stamen({
          layer: 'toner'
      
        })
      })
    }
  },

  o_struct_main_basemap: {
    s_MAIN_BASE_MAP_INTERNAL_NAME: 'carto_main_basemap'
  }
}


Module_Map.init = function()
{
  let moduleName = "map";
	private_objs.settings = xCore.modules[moduleName].settings;

  /*
  const key =
    'Your Mapbox access token from https://mapbox.com/ here';
    */

  let a_control_list = [
    new Zoom({
      className: 'ol-zoom'
    }),
    new ScaleLine({
      units: 'metric',
      className: 'ol-scale-line'
    })
  ];

  if (!xCoreHelper.f_page_is_in_mini_client_mode()) {
    a_control_list.push(
      new ScaleLine({
        units: 'metric',
        bar: true,
        text: true,
        className: 'ol-scale-bar-hidden'
      }),
      new ScaleControl(),
      new ImersiveModeControl(),
      new StreetViewModeControl()
    );
  }

  map = new Map({
    controls: a_control_list,
    layers: [new TileLayer(), new TileLayer()],
    target: 'map',
    view: new View({
      center: private_objs.settings.map_view_options.center,
      zoom: private_objs.settings.map_view_options.zoom,
    }),
  });

  f_init_base_map();

  //this.f_set_layer_osm();

  map.on('pointermove', evt => {
    if (!evt.dragging) {
      this.map.getTargetElement().style.cursor = this.map.hasFeatureAtPixel(this.map.getEventPixel(evt.originalEvent)) ? 'pointer' : '';
    }
  });

  map.on(['singleclick', 'click'], (evt) => {
    
    if(NSToolDraw.f_draw_tool_is_active())
    {
      return;
    }
    
    if (evt.type !== 'singleclick') return evt.stopPropagation();

    if (xCoreHelper.f_page_is_in_mini_client_mode())
    {
      let b_cancel_map_selection = NSMiniClientMain.f_map_obj_select_should_be_canceled();
      if(b_cancel_map_selection)
      {
        return;
      }
      
      
    }

    try {
      const pixel = evt.pixel;
      const b_incremental = evt.originalEvent.shiftKey;
      
      if (NSStreetView.f_is_enabled())
      {
        NSStreetView.f_process_map_click(pixel);
      }

      NSFeaturesSelect.f_request_features_by_click(pixel, b_incremental);

      evt.stopPropagation();
    } catch (err) {
      console.log('Failed to get features by click');
    }
});
  
  Module_Map.map = map;

  window.NSModule_Map_ = Module_Map;
}

Module_Map.f_get_ortos_info = function() {

  return private_objs.settings.a_layers_ortos;

}

function f_get_carto_main_basemap_info(s_ortos_layer_internal_name) 
{

  let s_MAIN_BASE_MAP_INTERNAL_NAME = private_objs.o_struct_main_basemap.s_MAIN_BASE_MAP_INTERNAL_NAME;

  let o_carto_main_basemap_info = private_objs.settings[s_MAIN_BASE_MAP_INTERNAL_NAME];

  return o_carto_main_basemap_info; 

}

function f_get_carto_altimetria_layer_info() 
{
  let o_carto_altimetria_layer_info = private_objs.settings['carto_altimetria_layer'];

  return o_carto_altimetria_layer_info; 

}

function f_get_ortos_layer_info(s_ortos_layer_internal_name) {

  let a_layers_ortos = private_objs.settings.a_layers_ortos;

  let o_ortos_layer_info = a_layers_ortos.find(element => element.internal_name == s_ortos_layer_internal_name);

  return o_ortos_layer_info; 

}

function f_init_base_map() {
  //let o_tile_layer = OverlaysWMTS.f_get_base_map_layer();
  //let s_base_layer_internal_name = 'ortos_2022';
  //private_objs.o_struct_layers.o_layers[s_base_layer_internal_name] = o_tile_layer;

  //Carto - Hibrid default layer
  f_prepare_carto_main_basemap_hibrid_layer();

  f_prepare_carto_altimetria_layer();


  //Ortos
  let a_layers_ortos = private_objs.settings.a_layers_ortos;

  for (let i = 0; i < a_layers_ortos.length; i++) {

    let ortos_info_i = a_layers_ortos[i];


    let o_tile_layer_i;
    if ( !xCoreHelper.f_page_is_in_ext_context() 
      && (ortos_info_i.internal_name_intra != null && ortos_info_i.internal_name_intra.length>0) )
    {
      o_tile_layer_i = OverlaysWMTS.f_get_base_map_layer(ortos_info_i.internal_name_intra);
      
    }
    else
    {
      o_tile_layer_i = OverlaysWMTS.f_get_base_map_layer(ortos_info_i.internal_name);
    }

    private_objs.o_struct_layers.o_layers[ortos_info_i.internal_name] = o_tile_layer_i;
  }
}

function f_prepare_carto_main_basemap_hibrid_layer()
{
  let o_get_carto_main_basemap_info = f_get_carto_main_basemap_info();
  let s_main_basemap_intrnal_name = o_get_carto_main_basemap_info.internal_name;
  let s_layer_internal_name_close_distance = o_get_carto_main_basemap_info.layer_internal_name_close_distance;
  let i_close_distance_min_zoom = o_get_carto_main_basemap_info.i_close_distance_min_zoom;
  let o_tile_layer_hibrid_basemap = OverlaysWMTS.f_get_main_basemap_layer(s_layer_internal_name_close_distance, i_close_distance_min_zoom);
  
  private_objs.o_struct_layers.o_layers[s_main_basemap_intrnal_name] = o_tile_layer_hibrid_basemap;

}

function f_prepare_carto_altimetria_layer()
{
  let o_get_carto_altimetria_layer_info = f_get_carto_altimetria_layer_info();
  let s_altimetria_internal_name = o_get_carto_altimetria_layer_info.internal_name;
  
  let o_carto_altimetria_layer = OverlaysWMTS.f_get_base_map_layer(s_altimetria_internal_name);
  
  private_objs.o_struct_layers.o_layers[s_altimetria_internal_name] = o_carto_altimetria_layer;
  
  map.getLayers().setAt(1, private_objs.o_struct_layers.o_layers[s_altimetria_internal_name]);
  
  Module_Map.f_set_layer_altimetria(false);
}


Module_Map.f_set_layer_osm = function()
{
  this.f_set_layer_by_internal_name("osm");
}
Module_Map.f_set_layer_terrain = function()
{
  this.f_set_layer_by_internal_name("terrain");
}
Module_Map.f_set_layer_toner = function()
{
  this.f_set_layer_by_internal_name("toner");
}
Module_Map.f_set_layer_watercolor = function()
{
  this.f_set_layer_by_internal_name("watercolor");
}
Module_Map.f_set_layer_ortos_2022 = function()
{
  this.f_set_layer_by_internal_name("ortos_2022");
}
Module_Map.f_set_layer_ortos_2023 = function()
{
  this.f_set_layer_by_internal_name("ortos_2023");
}
Module_Map.f_set_layer_by_internal_name = function(s_layer_internal_name)
{
  f_set_layer_by_internal_name_aux(s_layer_internal_name);
}
Module_Map.f_set_layer_planimetria = function(b_state)
{
  private_objs.o_struct_layers.o_layers['carto_main_basemap'].setVisible(b_state);
}
Module_Map.f_set_layer_altimetria = function(b_state)
{
  let o_get_carto_altimetria_layer_info = f_get_carto_altimetria_layer_info();
  let s_altimetria_internal_name = o_get_carto_altimetria_layer_info.internal_name;

  private_objs.o_struct_layers.o_layers[s_altimetria_internal_name].setVisible(b_state);
}

function f_set_layer_by_internal_name_aux(s_layer_internal_name)
{
  map.getLayers().setAt(0, private_objs.o_struct_layers.o_layers[s_layer_internal_name]);
  
  let o_ortos_layer_info = f_get_ortos_layer_info(s_layer_internal_name);
  let max_zoom = null;
  let min_zoom = null;
  if(o_ortos_layer_info != null) // not all layers are Ortos
  {
    max_zoom = o_ortos_layer_info.max_zoom;
    min_zoom = o_ortos_layer_info.min_zoom;
  }
  max_zoom = ( max_zoom == null )? private_objs.settings.map_view_options.maxZoom: max_zoom;
  min_zoom = ( min_zoom == null )? private_objs.settings.map_view_options.minZoom: min_zoom;
  
  map.getView().setMaxZoom(max_zoom);
  map.getView().setMinZoom(min_zoom);

  s_current_basemap_layer_internal_name = s_layer_internal_name;

}

Module_Map.if_orto_get_current_basemap_layer_internal_name = function()
{  
  
  let o_ortos_layer_info = f_get_ortos_layer_info(s_current_basemap_layer_internal_name);
  if(o_ortos_layer_info != null) // not all layers are Ortos
  {
    return s_current_basemap_layer_internal_name;
  }
  return null;
}


Module_Map.f_get_map = function()
{
  return map;
}

Module_Map.f_update_size = function()
{
  map.updateSize();
}

Module_Map.f_get_map_zoom = function()
{
  return map.getView().getZoom();
}




let o_struct_state = {
  private_objs:
  {
    state: 
    {
      tool_draw: {
        f_b_active: function(){ return NSToolDraw.f_draw_tool_is_active(); }
      },
      obj_edit: {
        f_b_active: function(){ return NSObjDetailsEdit.f_edit_section_is_active(); }
      },
      switch_parent: {
        b_active: false,
        f_cb: null
      },

      /*f_set_obj_edit: function(b_new_state)
      {
        this.obj_edit.b_active = b_new_state;
        if(!b_new_state)
        {
          this.f_set_switch_parent(false, null);
        }
      },*/
      f_set_switch_parent: function(b_new_state, f_cb)
      {
        this.switch_parent.b_active = b_new_state;
        this.switch_parent.f_cb = f_cb;
        if(!b_new_state)
        {
          this.switch_parent.f_cb = null;
        }
      },
      f_b_run_normal_map_click_obj_event: function()
      {
        let b_run_normal_map_click_obj_event = (  !this.tool_draw.f_b_active()
                                              && !this.obj_edit.f_b_active()
                                              && !this.switch_parent.b_active
                                            )? true: false;

        return b_run_normal_map_click_obj_event;
      },
      f_map_click_process_complementary_actions: function(s_urn_clicked_obj)
      {

        if(this.tool_draw.f_b_active())
        {
          
        }
        else if(this.switch_parent.b_active)
        {
          let f_cb = this.switch_parent.f_cb;
          f_cb(s_urn_clicked_obj);          
        }
        else if(this.obj_edit.f_b_active())
        {
          
        }

        return;
      }
    }

  }

}
Module_Map.state = {};
//Module_Map.state.f_get_tool_draw_is_active =      () => o_struct_state.private_objs.state.tool_draw.b_active;
Module_Map.state.f_get_tool_draw_is_active =      () => { return o_struct_state.private_objs.state.tool_draw.f_b_active(); };
Module_Map.state.f_get_obj_edit_is_active =       () => { return o_struct_state.private_objs.state.obj_edit.f_b_active(); };
Module_Map.state.f_get_switch_parent_is_active =  () => o_struct_state.private_objs.state.switch_parent.b_active;
/*
  -> returns function (s_urn)
*/
//Module_Map.state.f_get_switch_parent_f_callback = () => o_struct_state.private_objs.state.switch_parent.f_cb;

//Module_Map.state.f_set_tool_draw =     (b_new_state) => { o_struct_state.private_objs.state.tool_draw.b_active = b_new_state; };
//Module_Map.state.f_set_obj_edit =      (b_new_state) => { o_struct_state.private_objs.state.f_set_obj_edit(b_new_state); };
/*
  f_cb -> function(s_urn_parent)
*/
Module_Map.state.f_set_switch_parent = (b_new_state, f_cb) => { return o_struct_state.private_objs.state.f_set_switch_parent(b_new_state, f_cb);};


Module_Map.f_b_run_normal_map_click_obj_event = () => { return o_struct_state.private_objs.state.f_b_run_normal_map_click_obj_event(); };
/*
  s_urn_clicked_obj
*/
Module_Map.f_map_click_process_complementary_actions = (s_urn_clicked_obj) => { return o_struct_state.private_objs.state.f_map_click_process_complementary_actions(s_urn_clicked_obj) };

/** 
 * 
 * @returns: [x_min, y_min, x_max, y_max]
 * 
 */
Module_Map.f_get_map_bounds = function()
{
  //let a_bounds = map.getView().calculateExtent(map.getSize());
  // [x_min, y_min, x_max, y_max]
  let a_bounds = map.getView().calculateExtent();
  return a_bounds;
}
/** 
 * 
 * @returns: [x, y]
 * 
 */
Module_Map.f_get_map_center = function()
{
  //let a_bounds = map.getView().calculateExtent(map.getSize());
  // [x, y]
  let a_center = map.getView().getCenter();
  return a_center;
}
Module_Map.f_get_map_bounds_as_geo_json_feature = function()
{
  // [x_min, y_min, x_max, y_max]
  let a_bounds = Module_Map.f_get_map_bounds();
  let x_min = a_bounds[0];
  let y_min = a_bounds[1];
  let x_max = a_bounds[2];
  let y_max = a_bounds[3];
  let p0 = [x_min, y_min];
  let p1 = [x_max, y_min];
  let p2 = [x_max, y_max];
  let p3 = [x_min, y_max];
  let p4 = [x_min, y_min];

  let o_geojson_feature = NSGeoJson.f_get_geojson_feature_polygon_from_flatcoords([p0, p1, p2, p3, p4]);
  
  return o_geojson_feature;

}


